var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('CaseDemo',{attrs:{"mydata":_vm.caseDataList[5],"topTextColor":_vm.topTextColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }